var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：登录页面
 * 更新记录:
 */
import { Component, ViewChild } from '@angular/core';
import { SwJwtService } from '../librarys/serves/sw-jwt.service';
import { SwRouteguardService } from '../librarys/serves/sw-routeguard.service';
import { SwMenuService } from '../librarys/serves/sw-menu.service';
import { environment } from 'src/environments/environment';
import { SwLoadingmaskComponent } from '../librarys/components/basic-components/sw-loadingmask/sw-loadingmask.component';
import { Md5 } from "ts-md5";
import { SwHttpClientService } from '../librarys/serves/sw-http-client.service';
import { ConfigurationService } from '../librarys/serves/public/configuration.service';
import { OninitService } from '../librarys/serves/oninit.service';
import { SwMassageBoxService } from '../librarys/serves/sw-massage-box.service';
import { SwLoadingmaskService } from '../librarys/components/basic-components/sw-loadingmask/sw-loadingmask.service';
import { TranslateService } from '@ngx-translate/core';
import { SystemIdService } from '../librarys/serves/public/system-id.service';
import { ActivationEnd, Router } from '@angular/router';
var accountLoginComponent = /** @class */ (function () {
    function accountLoginComponent(_http, init, jwt, config, //初始化配置文件
    swMenus, box, //消息提示服务
    swRouter, systemId, swLoadingmaskService, //过渡效果
    translateService, router) {
        var _this = this;
        this._http = _http;
        this.init = init;
        this.jwt = jwt;
        this.config = config;
        this.swMenus = swMenus;
        this.box = box;
        this.swRouter = swRouter;
        this.systemId = systemId;
        this.swLoadingmaskService = swLoadingmaskService;
        this.translateService = translateService;
        this.router = router;
        this.msg = "";
        this.loginSystem = "";
        this.loginImage = '';
        this.projectLogo = "";
        this.projectLogoWidth = "";
        this.copyRight = ''; //版权信息
        this.systemData = [];
        this.partnerData = [];
        this.loginStyle = environment.loginStyle;
        this.closeEye = true;
        this.enableSsoLogin = environment.enableSsoLogin; //是否启用sso登录
        this.hasLogin = false;
        this.defualtlanguage = 'zh-CN'; //默认语言
        this.languages = [{ id: 'zh-CN', text: '中文简体' }, { id: 'en-US', text: 'English' }]; //所有语言
        this.isLanguage = false; //是否使用切换语言
        this.isVcode = true; //是否有验证码功能
        this.isSlideVerify = false; //滑动验证码是否通过；默认为false，未通过；true通过
        this.isSliderCode = false; //登录界面是否有滑动验证功能,默认不需要滑动验证,值为false
        this.LoginModel = {
            loginName: '',
            systemCode: '',
            loginPassword: '',
            vcode: '',
            partnerCode: ''
        };
        this.img = "";
        this.router.events.subscribe(function (event) {
            if (event instanceof ActivationEnd) {
                var param = event.snapshot["queryParams"];
                if (param && param['token']) {
                    _this.hasLogin = true;
                    _this.login1(param['token'], param['systemId']);
                }
                if (param && param['customerId']) {
                    _this.jwt.setToKen("customerId", param['customerId']); //如果是从saas过来的，会带上customerId,存储下来，用于header中获取用户的租户
                }
            }
        });
        this.defualtlanguage = environment.defaultLanguage;
        if (environment.defaultLanguage) {
            this.isLanguage = true;
        }
        this.isSliderCode = environment.isSliderCode;
    }
    accountLoginComponent.prototype.ngOnInit = function () {
        //如果是soo登录，执行以下步骤
        if (environment.enableSsoLogin) {
            var systemId = this.systemId.getSystemId();
            var code = this.getQueryVariable("code");
            if (code) {
                //存在则先请求一次带code的请求头，拿到token
                var headers = {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'code': code
                };
                this._http.Post(environment.seekerWebAPI + "sw/init?systemId=" + systemId, {}, headers).subscribe(function (data) {
                });
            }
            else {
                //不存在说明没有进行过sso登陆
                this._http.Post(environment.seekerWebAPI + "sw/init?systemId=" + systemId, {}).subscribe(function (data) {
                });
            }
            return false;
        }
        if (!this.hasLogin) {
            this.multiTenancy = environment.multiTenancy;
            this.location();
            this.getimg();
        }
        //获取当前语言
        if (this.translateService.currentLang) {
            this.defualtlanguage = this.translateService.currentLang;
        }
    };
    accountLoginComponent.prototype.ngAfterViewInit = function () {
        //初始化滑动模块验证功能
        this.initSlideVerify();
    };
    accountLoginComponent.prototype.getQueryVariable = function (variable) {
        try {
            var query = window.location.hash.split("?")[1];
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    return pair[1];
                }
            }
            return (false);
        }
        catch (_a) {
            return (false);
        }
    };
    //
    //滑动验证初始化 
    accountLoginComponent.prototype.initSlideVerify = function () {
        var that = this;
        this.isSlideVerify = false;
        $('#mpanel1').empty();
        $('#mpanel1').slideVerify({
            type: 1,
            vOffset: 3,
            barSize: {
                width: '100%',
                height: '38px',
            },
            language: this.defualtlanguage,
            ready: function () {
            },
            success: function () {
                that.isSlideVerify = true;
            },
            error: function () {
            }
        });
    };
    //密码切换眼睛功能
    accountLoginComponent.prototype.clickEye = function () {
        this.closeEye = !this.closeEye;
    };
    accountLoginComponent.prototype.enterKeyword = function (event) {
        var str = event.target.value;
        //包含大小写字母、数字和特殊字符，至少8位
        var reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[1-9])(?=.*[\W]).{8,}$/;
    };
    accountLoginComponent.prototype.onSubmit = function (_a, event) {
        var _this = this;
        var value = _a.value, valid = _a.valid;
        this.msg = "";
        //包含大小写字母、数字和特殊字符，至少8位
        // let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[1-9])(?=.*[\W]).{8,}$/
        // if(!reg.test(value.loginPassword)){
        //   this.msg = '密码在8位以上、含大小写、数字、特殊字符'
        //   return
        // }
        if (valid) {
            //登陆先打开loading遮罩层 
            //登陆先打开loading遮罩层
            this.swLoadingmaskService.openLoading();
            var pwd_1 = Md5.hashStr(value.loginPassword);
            //在这要替换掉特殊字符串,不然会出现BUG
            value.loginName = value.loginName.replace('&', '%26');
            if (value.vcode) {
                value.vcode = value.vcode.replace('&', '%26');
            }
            // partnerCode
            if (!environment.multiTenancy) {
                value.systemCode = environment.systemCode;
            }
            //二次加密loginPassword
            var pwdvid_1; //二次加密后的密码
            if (value.vid) {
                //有验证码的情况下：
                //先转换成大写 
                var uperPwd = pwd_1.toString().toLocaleUpperCase();
                var uperVid = value.vid.toLocaleUpperCase();
                pwdvid_1 = Md5.hashStr(uperPwd + uperVid);
                // console.log("pwd:"+pwd);
                var path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwd_1 + "&systemCode=" + value.systemCode;
                if (environment.encryptedPassword == true) {
                    //需要加密
                    path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwdvid_1 + "&systemCode=" + value.systemCode;
                }
                var parms = {
                    loginName: value.loginName,
                    loginPassword: pwd_1,
                    systemCode: value.systemCode,
                    vcode: value.vcode,
                    vid: value.vid,
                    partnerCode: null
                };
                if (this.LoginModel.partnerCode) {
                    path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwd_1 + "&systemCode=" + value.systemCode + "&partnerCode=" + value.partnerCode;
                    if (environment.encryptedPassword == true) {
                        //需要加密
                        path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwdvid_1 + "&systemCode=" + value.systemCode + "&partnerCode=" + value.partnerCode;
                    }
                    parms.partnerCode = value.partnerCode;
                }
                path += "&vcode=" + value.vcode + "&vid=" + value.vid;
                this.entryLogin(path, true);
            }
            else {
                //无验证码的情况下，先获得验证码再加密：
                this._http.Post(environment.seekerWebAPI + "sw/queryVCode", {}).subscribe(function (data) {
                    if (data["code"] == 200) {
                        var uperPwd = pwd_1.toString().toLocaleUpperCase();
                        var vid = data["data"]["vid"].toString().toLocaleUpperCase();
                        pwdvid_1 = Md5.hashStr(uperPwd + vid);
                        var path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwd_1 + "&systemCode=" + value.systemCode;
                        if (environment.encryptedPassword == true) {
                            //需要加密
                            path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwdvid_1 + "&systemCode=" + value.systemCode;
                        }
                        var parms = {
                            loginName: value.loginName,
                            loginPassword: pwd_1,
                            systemCode: value.systemCode,
                            vcode: value.vcode,
                            vid: value.vid,
                            partnerCode: null
                        };
                        if (_this.LoginModel.partnerCode) {
                            path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwd_1 + "&systemCode=" + value.systemCode + "&partnerCode=" + value.partnerCode;
                            if (environment.encryptedPassword == true) {
                                //需要加密
                                path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwdvid_1 + "&systemCode=" + value.systemCode + "&partnerCode=" + value.partnerCode;
                            }
                            parms.partnerCode = value.partnerCode;
                        }
                        path += "&vid=" + data["data"]["vid"];
                        _this.entryLogin(path, false);
                    }
                });
            }
        }
    };
    //  onSubmit({ value, valid }, event: Event) {
    //   this.msg = "";
    //   if (valid) {
    //     this._http.Post(environment.saasWebAPI + "saas/queryVCode", {}).subscribe(data => {
    //       let vid = data.data.vid;
    //       let loginName = value.loginName;
    //       let loginPassword = value.loginPassword;
    //       loginPassword = Md5.hashStr(loginPassword);
    //       loginPassword = Md5.hashStr(loginPassword.toLocaleUpperCase() + vid.toLocaleUpperCase());
    //       loginPassword = loginPassword.toLocaleUpperCase()
    //       let url = environment.saasWebAPI + `saas/login?name=${loginName}&loginPassword=${loginPassword}&vid=${vid}`;
    //       this._http.Post(url, {}).subscribe(res => {
    //         let systemId = res.data.systemId;
    //         let token = res.data.authorizationu;
    //         let url = `./#/login?token=${token}&systemId=${systemId}`
    //         // let url = `http://localhost:4200/#/login?token=${token}&systemId=${systemId}`
    //         window.location.href = url;
    //       })
    //     })
    //   }
    // }
    //登录接口
    accountLoginComponent.prototype.entryLogin = function (path, isVid) {
        var _this = this;
        this._http.Post(path, null).subscribe(function (data) {
            if (data["code"] == 200) {
                if (_this.LoginModel.partnerCode) {
                    window.open("http://www.baidu.com", "_self");
                    return;
                }
                _this.init.GC(); // 清除缓存，工作台和路由复用
                // this.Jwt.setlocaToken("token", data["data"]["jwt"]); //添加新的token
                _this.jwt.setToKen("language", _this.defualtlanguage); //登录成功后将当前语言设置存进缓存
                _this.jwt.setToKen("token", data["data"]["authorizationu"]); //添加新的token
                _this.jwt.removeItem("TabMenu"); //添加新的工作台
                _this.jwt.setToKen("systemId", data["data"]["systemId"]);
                _this.swMenus.location('login');
                //密码过期提醒
                if (data["data"]["expire"]) {
                    _this.box.danger(data["data"]["expire"]);
                }
                _this.swMenus.valueUpdated.subscribe(function (val) {
                    if (!val) {
                        if (isVid) {
                            _this.getimg();
                        }
                    }
                });
            }
            else if (data["msg"]) {
                _this.swLoadingmaskService.closeLoading();
                if (isVid) {
                    _this.getimg();
                } //重新获取验证码
                _this.LoginModel.vcode = ''; //验证码输入框清空
                _this.msg = data["msg"];
                _this.initSlideVerify();
            }
        });
    };
    accountLoginComponent.prototype.login1 = function (jwt, systemId) {
        var _this = this;
        this.init.GC(); // 清除缓存，工作台和路由复用
        // this.Jwt.setlocaToken("token", data["data"]["jwt"]); //添加新的token
        this.jwt.setToKen("token", jwt); //添加新的token
        this.jwt.removeItem("TabMenu"); //添加新的工作台
        this.jwt.setToKen("systemId", systemId);
        this.swMenus.location('login');
        this.swMenus.valueUpdated.subscribe(function (val) {
            if (!val) {
                _this.getimg();
            }
        });
    };
    accountLoginComponent.prototype.location = function () {
        // this.config.inItConfig();
        // this.inItConfig();
        //如果是多租户,采取获取登录页面系统下拉框列表
        if (this.multiTenancy) {
            this.getSystemData();
        }
        this.initValue();
    };
    //初始值
    accountLoginComponent.prototype.initValue = function () {
        this.loginSystem = environment.projectName;
        this.copyRight = environment.coptyRight;
        this.loginImage = environment.loginBackGround;
        this.projectLogo = environment.projectLogo;
        this.projectLogoWidth = environment.projectLogoWidth;
        this.isVcode = environment.isVcode;
    };
    accountLoginComponent.prototype.clickdianji = function () {
        $.support.transition = true;
    };
    accountLoginComponent.prototype.getPartner = function (systemCode) {
        var _this = this;
        this.partnerData = [];
        this.LoginModel.partnerCode = '';
        var sysetem = this.systemData.find(function (x) { return x.systemCode == systemCode; });
        this._http.Get(environment.seekerWebAPI + "sw/queryPartnersBySystemId?systemId=" + sysetem.systemId, {}).subscribe(function (data) {
            if (data["code"] == 200) {
                _this.partnerData = data["data"];
            }
        });
    };
    //初始化配置文件
    accountLoginComponent.prototype.inItConfig = function () {
        var _this = this;
        try {
            if (this.config.config) {
                this.loginSystem = this.config.config.find(function (x) { return x.configKey == "SYS_PROJECT_NAME"; }).configValue;
                var image = this.config.config.find(function (x) { return x.configKey == "SYS_LOGIN_BACKGROUND"; }).configValue;
                // this.loginImage = "url("+image+") no-repeat center/cover;"
                this.copyRight = this.config.config.find(function (x) { return x.configKey == "SYS_COPYRIGHT_STATE"; }).configValue;
            }
            else {
                this.config.configpdated.subscribe(function (data) {
                    _this.loginSystem = data.find(function (x) { return x.configKey == "SYS_PROJECT_NAME"; }).configValue;
                    var image = data.find(function (x) { return x.configKey == "SYS_LOGIN_BACKGROUND"; }).configValue;
                    // this.loginImage = "url("+image+")  no-repeat center/cover"
                    _this.copyRight = data.find(function (x) { return x.configKey == "SYS_COPYRIGHT_STATE"; }).configValue;
                });
            }
        }
        catch (e) { }
    };
    accountLoginComponent.prototype.getSystemData = function () {
        var _this = this;
        //请求数据
        this._http.Post(environment.seekerWebAPI + "sw/querySystems", {}).subscribe(function (data) {
            if (data["code"] == 200) {
                _this.systemData = data["data"];
            }
        });
    };
    accountLoginComponent.prototype.getimg = function () {
        var _this = this;
        this._http.Post(environment.seekerWebAPI + "sw/queryVCode", {}).subscribe(function (data) {
            if (data["code"] == 200) {
                _this.img = "data:image/jpeg;base64," + data["data"]["image"];
                _this.LoginModel.vid = data["data"]["vid"];
            }
        });
    };
    //输入用户名的时候直接将 ` 全部替换成空字符串,否则会直接报错400 Bad Request
    accountLoginComponent.prototype.enterName = function (event) {
        if (event.key == '`') {
            this.LoginModel.loginName = event.target.value.replace(/`/g, '');
        }
    };
    //切换语言触发
    // changeEnter(event){
    //   this.defualtlanguage=event.target.value;
    //   this.translateService.use(event.target.value);
    // }
    //切换语言
    accountLoginComponent.prototype.selectLanguage = function (language) {
        this.defualtlanguage = language.id;
        this.translateService.use(language.id);
        this.initSlideVerify();
    };
    //匹配选中的语言
    accountLoginComponent.prototype.getLanguageText = function () {
        var _this = this;
        var lan = this.languages.filter(function (item) { return item.id == _this.defualtlanguage; });
        if (lan.length > 0) {
            return lan[0].text;
        }
    };
    __decorate([
        ViewChild("loading"),
        __metadata("design:type", SwLoadingmaskComponent)
    ], accountLoginComponent.prototype, "loading", void 0);
    accountLoginComponent = __decorate([
        Component({
            selector: 'account-login',
            template: require("./accountLogin.component.html"),
            styles: [require("./accountLogin.component.css")]
        }),
        __metadata("design:paramtypes", [SwHttpClientService,
            OninitService,
            SwJwtService,
            ConfigurationService,
            SwMenuService,
            SwMassageBoxService,
            SwRouteguardService,
            SystemIdService,
            SwLoadingmaskService,
            TranslateService,
            Router])
    ], accountLoginComponent);
    return accountLoginComponent;
}());
export { accountLoginComponent };
//# sourceMappingURL=accountLogin.component.js.map